<!--21-游客统计-->
<template>
  <div class="pm50">
    <div class="pd jhnstop row">
      <p class="col">
        <img src="../../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome">首页</span>
    </div>
    <div>
      <van-dropdown-menu>
        <van-dropdown-item v-model="statInput.startCTime" :options="option1" />
      </van-dropdown-menu>
    </div>    
    <div>
      <div class="pd pt20">
        <p>
          <span class="jjnjjjert">按年龄段</span>
        </p>
      </div>
      <div v-if="loading1">
        <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
      </div>
      <div class="kmmmxeert" v-else-if="shujub.xAxis[0].data.length > 0">
        <tubiao v-model="shujub"></tubiao>
      </div>
      <div v-else>
        <no-data :content-height="80"></no-data>
      </div>
      <!-- <div class="pd pt20">
        <p>
          <span class="jjnjjjert">按性别</span>
        </p>
      </div>
      <div v-if="loading2">
        <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
      </div>
      <div v-else-if="shujuc.series[0].data.length > 0">
        <div class="kmmmxeert afdgfdty">
          <tubiao v-model="shujuc"></tubiao>
        </div>
      </div>
      <div v-else>
        <no-data :content-height="80"></no-data>
      </div> -->
      <div class="pd pt20">
        <p>
          <span class="jjnjjjert">按地区</span>
        </p>
        <div v-if="loading3">
          <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
        </div>
        <div class="jinunjser" v-else-if="statTouristBySexData.rows.length > 0">
          <div class="kmmmxeert afdgfdty mt10">
            <tubiao v-model="shujud"></tubiao>
          </div>
          <div
            class="mt10"
            v-for="(row, idx) in statTouristBySexData.rows"
            :key="row.地区"
          >
          <div class="row" v-if="idx<10">
            <p class="kjnmkxer fz14 z3">{{ row.地区 }}</p>
            <div class="gdfyuywwr ml10">
              <span :style="getWidth(statTouristBySexData, idx)"></span>              
            </div>
            <p class="col zts fz14 tr areanum">{{ row.合计 }}</p>
          </div>
          <div v-if="idx==10 && !loadMore" class="cen" @click="loadMore=true">加载更多</div>
          <div class="row"  v-if="idx>=10 && loadMore">
            <p class="kjnmkxer fz14 z3">{{ row.地区 }}</p>
            <div class="gdfyuywwr ml10">
              <span :style="getWidth(statTouristBySexData, idx)"></span>
            </div>
            <p class="col zts fz14 tr areanum">{{ row.合计 }}</p>
          </div>
          <div v-if="idx==statTouristBySexData.rows.length-1 && statTouristBySexData.rows.length>10 && loadMore" class="cen" @click="loadMore=false">收起</div>
          </div>
        </div>
        <div v-else>
          <no-data :content-height="80"></no-data>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tubiao from "@/components/tubiao";
import moment from "moment";
import ticketService from "@/services/ticketService.js";
import NoData from "@/components/NoData.vue";

function Shujub() {
  this.color = ["#3C8046"];
  this.tooltip = {
    trigger: "axis",
    axisPointer: {
      // 坐标轴指示器，坐标轴触发有效
      type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
    },
  };
  this.grid = {
    left: "3%",
    right: "4%",
    bottom: "3%",
    top: "10%",
    containLabel: true,
  };
  this.xAxis = [
    {
      type: "category",
      data: [],
      axisTick: {
        alignWithLabel: true,
      },
      axisLine: {
        //最外面的边框颜色
        lineStyle: {
          color: "#999999",
        },
      },
    },
  ];
  this.yAxis = [
    {
      type: "value",
      axisLine: {
        //最外面的边框颜色
        lineStyle: {
          color: "#999999",
        },
      },
    },
  ];
  this.series = [
    {
      name: "直接访问",
      type: "bar",
      barWidth: "40%",
      label: {
        show: true,
        position: "top",
      },
      data: [],
    },
  ];
}

function Shujuc() {
  (this.tooltip = {
    trigger: "item",
    // formatter: '{a} <br/>{b} : {c} ({d}%)'
    formatter: "{b} : {c} <br/> ({d}%)",
  }),
    (this.series = [
      {
        name: "访问来源",
        type: "pie",
        radius: ["35%", "60%"],
        label: {
          formatter: "{b} {per|{d}%}",
          rich: {
            per: {
              color: "#eee",
              backgroundColor: "#603531",
              padding: [2, 4],
              borderRadius: 2,
            },
          },
        },
        data: [],
        roseType: "radius",
        color: ["#A9716D", "#3C8046", "#3C7080"],
      },
    ]);
}
function Shujud() {
  (this.tooltip = {
    trigger: "item",
    // formatter: '{a} <br/>{b} : {c} ({d}%)'
    formatter: "{b} : {c} <br/> ({d}%)",
  }),
    (this.series = [
      {
        name: "访问来源",
        type: "pie",
        radius: ["35%", "60%"],
        label: {
          formatter: "{b} {per|{d}%}",
          rich: {
            per: {
              color: "#eee",
              backgroundColor: "#603531",
              padding: [2, 4],
              borderRadius: 2,
            },
          },
        },
        data: [],
        roseType: "radius",
        color: ["#A9716D", "#3C8046", "#3C7080"],
      },
    ]);
}
export default {
  data() {
    return {
      loadMore: false,
      loading1: false,
      loading2: false,
      loading3: false, 
      statInput: {
        startCTime: moment().format("YYYY-MM-DD"),
        endCTime: moment().add(1, "days").format("YYYY-MM-DD"),
      },
      option1: [
        {
          text: "今天",
          value: moment().format("YYYY-MM-DD")
        },
        // {
        //   text: "最近一周",
        //   value: moment()
        //   .subtract(1, "weeks")
        //   .format("YYYY-MM-DD")
        // },
        {
          text: "最近一个月",
          value: moment().subtract(1, "months").format("YYYY-MM-DD"),
        },
        {
          text: "最近二个月",
          value: moment().subtract(2, "months").format("YYYY-MM-DD"),
        },
        {
          text: "最近三个月",
          value: moment().subtract(3, "months").format("YYYY-MM-DD"),
        },
      ],

      shujub: new Shujub(),
      shujuc: new Shujuc(),
      shujud: new Shujud(),
      statTouristBySexData: {
        rows: [],
        totalNum: 0,
      },
    };
  },

  components: {
    tubiao,
    NoData,
  },
  watch: {
    "statInput.startCTime": function () {
      this.loadData();
    },
  },
  methods: {
    getWidth(data, idx) {
      return "width:" + this.getPercent(data, idx);
    },
    getPercent(data, idx) {
      if (data.totalNum == 0) {
        return "0%";
      }
      let width = parseInt((data.rows[idx].合计 / data.totalNum) * 100);
      return width + "%";
    },
    toHome() {
      this.$router.push("/");
    },
    loadData() {
      this.loading1 = true;
      this.loading2 = true;
      this.loading3 = true;
      ticketService
        .statTouristByAgeRangeAsync(this.statInput)
        .then((result) => {
          this.shujub.xAxis[0].data = [];
          this.shujub.series[0].data = [];

          for (var i = 1; i < result.columns.length - 1; i++) {
            this.shujub.xAxis[0].data.push(result.columns[i]);

            var num = 0;
            for (var j = 0; j < result.data.length; j++) {
              num += result.data[j][result.columns[i]];
            }
            this.shujub.series[0].data.push(num);
          }
        }).catch(() => {

        })
        .finally(() => {
          this.loading1 = false;
        });

      // ticketService
      //   .statTouristBySexAsync(this.statInput)
      //   .then((result) => {
      //     this.shujuc.series[0].data = [];
      //     for (var i = 1; i < result.columns.length - 1; i++) {            
      //       var num = 0;
      //       for (var j = 0; j < result.data.length; j++) {
      //         num += result.data[j][result.columns[i]];
      //       }
      //       this.shujuc.series[0].data.push({
      //         value: num,
      //         name: result.columns[i],
      //       });
      //     }
      //   }).catch(() => {

      //   })
      //   .finally(() => {
      //     this.loading2 = false;
      //   });
      ticketService
        .statTouristByAreaAsync(this.statInput)
        .then((result) => {
          this.shujud.series[0].data = [];
          this.statTouristBySexData.rows = result.data;
          var num = 0;
          for (var i = 0; i < result.data.length; i++) {
            num += result.data[i].合计;
            if(i<10)
            {                
              this.shujud.series[0].data.push({
                value: result.data[i].合计,
                name: result.data[i].地区,
              });
            }
          }
          this.statTouristBySexData.totalNum = num;
          
        }).catch(() => {

        })
        .finally(() => {
          this.loading3 = false;
        });

      // Promise.all([statTouristByAgeRange, statTouristBySex, statTouristByArea])
      //   .then(() => {})
      //   .catch(() => {

      //   })
      //   .finally(() => {
      //     this.loading1 = false;
      //   });
    },
  },
  mounted() {},
  created() {
    this.loadData();
  },
};
</script>
<style scoped>
.kmmmxeert {
  height: 210px;
}

.afdgfdty {
  margin-top: -20px;
}
.kjnmkxer {
  width: 20%;
}
.gdfyuywwr {
  width: 80%;
  top: 3px;
}
.loading{
  margin-top: 10px;
  text-align: center;
}
.areanum{
  position: absolute;
    right: 15px;
    z-index: 100;
    margin-top: 2px;
}
</style>
